"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function changeAlternateText({ replaceVariables, }) {
    return (state, actions, { tabName = state.ui.currentTabName, imageAlternativeText }) => () => {
        const finalImageAlternativeText = (replaceVariables(imageAlternativeText) || '').trim();
        actions.setters.setImageAltText({ tabName, imageAlternativeText, finalImageAlternativeText });
        actions.effects.recalculateWarnings({ tabName });
    };
}
exports.changeAlternateText = changeAlternateText;
//# sourceMappingURL=change-alternate-text.js.map